'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('ChangePasswordCtrl', ChangePasswordCtrl);
  ChangePasswordCtrl.$inject = ['authenticationSvc', 'msAuth', '$stateParams', '$timeout'];

  function ChangePasswordCtrl(authenticationSvc, msAuth, $stateParams, $timeout) {
    var vm = this;
    vm.isPwExpire = $stateParams.isPasswordExpiration;
    vm.$onInit = activate;

    vm.resetPassword = function () {
      vm.pending = true;
      authenticationSvc.resetPassword(vm.password1).then(function () {
        vm.success = true;
        msAuth.logout();
      }, function (err) {
        vm.error = err.data && err.data.errorCode || 'UNKNOWN';
        if (vm.error === 'PASSWORD_MATCHES_PREVIOUS') {
          vm.passwordResetForm.password1.$setValidity('duplicate', false);
        }
      }).finally(function () {
        return vm.pending = false;
      });
    };

    function focusMainContent() {
      $timeout(function () {
        var mainContent = angular.element('article');
        if (mainContent && mainContent[0]) {
          mainContent[0].focus();
        }
      }, 100);
    }

    function activate() {
      focusMainContent();
    }
  }
})();